<template lang="html">
    <div>
        <div class="container container-medium mt-3 article reading">
            <p>Nu se pot emite roviniete cu data de valabilitate anterioara datei de emitere.</p>

            <p>Nu se pot emite roviniete decat cu cel mult 30 zile anterior datei de inceput a valabilitatii.</p>

            <p>Rovinietele se emit numai dupa confirmarea platii sumei in contul bancar al UNTRR (in cateva minute in cazul platii online cu cardul bancar finalizate sau cateva zile in cazul platii prin ordin de plata).</p>

            <p>In conformitate cu dispozitiile art. 1 alin. 1 lit.j din OG 15/2002, aprobata de Legea 424/2002, rovinieta este definita ca fiind documentul sau inregistrarea in format electronic care atesta achitarea tarifului de utilizare a retelei de drumuri nationale din Romania. Modelul, forma, continutul, modul, conditiile si mijloacele de eliberare ale rovinietei se stabilesc prin normele metodologice aprobate prin ordin al ministrului transporturilor si infrastructurii.</p>

            <p>Tariful de utilizare este structurat in functie de durata de utilizare a retelei de drumuri nationale din Romania ( o zi, 30 de zile, 90 de zile, 12 luni). Durata de utilizare cuprinde durata de parcurs, precum si durata de stationare.</p>

            <p>Tariful de utilizare stablit prin Ordonanta 8 din 2010 este urmatorul:</p>

            <div class="table-responsive">
                <table class="table table-stripped" width="800">
                    <tr>
                        <th width="100">Categoria</th>
                        <th width="500">Tipul vehiculului</th>
                        <th width="200">Durata de utilizare a retelei de drumuri nationale din Romania</th>
                        <th width="200">Tariful [EURO] (TVA inclus)</th>
                    </tr>
                    <tr>
                        <th>Category</th>
                        <th>Type of vehicle</th>
                        <th>Period of use of national road network in Romania</th>
                        <th>Tariff [EURO] (including VAT)</th>
                    </tr>

                    <tr>
                        <td rowspan="5">A</td>
                        <td rowspan="5">
                            <p>autoturism</p>
                            <p>car</p>
                        </td>
                        <td>-</td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>7 zile / days</td>
                        <td>3</td>
                    </tr>
                    <tr>
                        <td>30 zile / days</td>
                        <td>7</td>
                    </tr>
                    <tr>
                        <td>90 zile / days</td>
                        <td>13</td>
                    </tr>
                    <tr>
                        <td>12 luni / months</td>
                        <td>28</td>
                    </tr>

                    <tr>
                        <td rowspan="5">B</td>
                        <td rowspan="5">
                            <p>vehicule de transport marfa cu MTMA mai mica sau egala de 3.5 tone</p>
                            <p>goods transport vehicle with maximum total weight authorized less or equal to 3.5 t</p>
                        </td>
                        <td>-</td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>7 zile / days</td>
                        <td>6</td>
                    </tr>
                    <tr>
                        <td>30 zile / days</td>
                        <td>16</td>
                    </tr>
                    <tr>
                        <td>90 zile / days</td>
                        <td>36</td>
                    </tr>
                    <tr>
                        <td>12 luni / months</td>
                        <td>96</td>
                    </tr>

                    <tr>
                        <td rowspan="5">C</td>
                        <td rowspan="5">
                            <p>vehicule de transport marfa cu MTMA mai mare de 3.5 tone si mai mica sau egala de 7.5 tone</p>
                            <p>goods transport vehicle with maximum total weight authorized more than 3.5 t and less or equal to 7.5t</p>
                        </td>
                        <td>1 zi / day</td>
                        <td>4</td>
                    </tr>
                    <tr>
                        <td>7 zile / days</td>
                        <td>16</td>
                    </tr>
                    <tr>
                        <td>30 zile / days</td>
                        <td>32</td>
                    </tr>
                    <tr>
                        <td>90 zile / days</td>
                        <td>92</td>
                    </tr>
                    <tr>
                        <td>12 luni / months</td>
                        <td>320</td>
                    </tr>

                    <tr>
                        <td rowspan="5">D</td>
                        <td rowspan="5">
                            <p>vehicule de transport marfa cu MTMA mai mare de 7.5 tone si mai mica de 12 tone</p>
                            <p>goods transport vehicle with maximum total weight authorized more than 7,5 t and less than 12t</p>
                        </td>
                        <td>1 zi / day</td>
                        <td>7</td>
                    </tr>
                    <tr>
                        <td>7 zile / days</td>
                        <td>28</td>
                    </tr>
                    <tr>
                        <td>30 zile / days</td>
                        <td>56</td>
                    </tr>
                    <tr>
                        <td>90 zile / days</td>
                        <td>160</td>
                    </tr>
                    <tr>
                        <td>12 luni / months</td>
                        <td>560</td>
                    </tr>

                    <tr>
                        <td rowspan="5">E</td>
                        <td rowspan="5">
                            <p>vehicule de transport marfa cu MTMA mai mare sau egala de 12 tone, cu maximum 3 axe (inclusiv)</p>
                            <p>goods transport vehicle with maximum total weight authorized more or equal to 12 t, maximum 3 axles (including)</p>
                        </td>
                        <td>1 zi / day</td>
                        <td>9</td>
                    </tr>
                    <tr>
                        <td>7 zile / days</td>
                        <td>36</td>
                    </tr>
                    <tr>
                        <td>30 zile / days</td>
                        <td>72</td>
                    </tr>
                    <tr>
                        <td>90 zile / days</td>
                        <td>206</td>
                    </tr>
                    <tr>
                        <td>12 luni / months</td>
                        <td>720</td>
                    </tr>

                    <tr>
                        <td rowspan="5">F</td>
                        <td rowspan="5">
                            <p>vehicule de transport marfa cu MTMA mai mare sau egala de 12 tone, cu minimum 4 axe (inclusiv)</p>
                            <p>goods transport vehicle with total maximum authorized weight more or equal to 12 t, minimum 4 axles (including)</p>
                        </td>
                        <td>1 zi / day</td>
                        <td>11</td>
                    </tr>
                    <tr>
                        <td>7 zile / days</td>
                        <td>55</td>
                    </tr>
                    <tr>
                        <td>30 zile / days</td>
                        <td>121</td>
                    </tr>
                    <tr>
                        <td>90 zile / days</td>
                        <td>345</td>
                    </tr>
                    <tr>
                        <td>12 luni / months</td>
                        <td>1210</td>
                    </tr>

                    <tr>
                        <td rowspan="5">G</td>
                        <td rowspan="5">
                            <p>vehicule de transport persoane cu mai mult de 9 locuri pe scaune (inclusiv conducatorul auto) si maximum 23 locuri pe scaune (inclusiv conducatorul auto)</p>
                            <p>passenger transport vehicles with more than 9 seats (including the driver) and maximum 23 seats (including the driver)</p>
                        </td>
                        <td>1 zi / day</td>
                        <td>4</td>
                    </tr>
                    <tr>
                        <td>7 zile / days</td>
                        <td>20</td>
                    </tr>
                    <tr>
                        <td>30 zile / days</td>
                        <td>52</td>
                    </tr>
                    <tr>
                        <td>90 zile / days</td>
                        <td>120</td>
                    </tr>
                    <tr>
                        <td>12 luni / months</td>
                        <td>320</td>
                    </tr>

                    <tr>
                        <td rowspan="5">H</td>
                        <td rowspan="5">
                            <p>vehicule de transport persoane cu mai mult de 23 locuri pe scaune (inclusiv conducatorul auto)</p>
                            <p>passenger transport vehicles with more than 23 seats (including the driver)</p>
                        </td>
                        <td>1 zi / day</td>
                        <td>7</td>
                    </tr>
                    <tr>
                        <td>7 zile / days</td>
                        <td>35</td>
                    </tr>
                    <tr>
                        <td>30 zile / days</td>
                        <td>91</td>
                    </tr>
                    <tr>
                        <td>90 zile / days</td>
                        <td>210</td>
                    </tr>
                    <tr>
                        <td>12 luni / months</td>
                        <td>560</td>
                    </tr>
                </table>
            </div>

            <p>Pentru autoturismele si pentru vehiculele de transport marfa cu masa totala maxima autorizata mai mica sau egala cu 3,5 tone, durata minima pentru care se poate achita tariful de utilizare este de 7 zile.</p>

            <p>Responsabilitatea achitarii tarifului de utilizare si a detinerii rovinietei valabile, precum si a achitarii tarifului de trecere sau a tarifului de concesiune revine in exclusivitate utilizatorilor romani, iar in cazul utilizatorilor straini, acesta revine in exclusivitate conducatorului auto a vehiculului.</p>

            <p>Fapta de a circula fara a detine rovinieta valabila constituie contraventie si se sanctioneaza cu amenda.</p>

            <p>Contravenientul are obligatia de a achita, pe langa amenda contraventionala, cu titlu de tarif de despagubire, in functie de tipul vehiculului folosit fara a detine rovinieta valabila, sumele stabilite potrivit anexei a a OUG 15/2002 cu modificarile si completarile ulterioare.</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AboutErovContent'
    }

</script>

<style lang="scss" scoped>

</style>
